export const CHARACTER_CAROUSEL_IMAGES = [
  '/Home/Character-Badtz-maru.avif',
  '/Home/Character-Chococat.avif',
  '/Home/Character-Cinnamonroll.avif',
  '/Home/Character-Hangyodon.avif',
  '/Home/Character-HelloKitty.avif',
  '/Home/Character-MyMelody.avif',
  '/Home/Character-Pekkle.avif',
];

export const HOME_MENU_ICONS = [
  '/Home/Home.webp',
  '/Home/Card.webp',
  '/Home/Story.webp',
  '/Home/Asset.webp',
  '/Home/Shop.webp',
  '/Home/Winner.webp',
  '/Home/Referral.webp',
];

export const HOME_QUICK_ACTIONS = [
  '/Home/night.png',
  '/Home/Passport.webp',
  '/Home/Music.webp',
];

export const PASSPORT_IMAGES = [
  '/Passport/bg.webp',
  '/Passport/hello.png',
  '/Passport/papion.png',
  '/Passport/heart.png',
  '/Passport/plane.png',
  '/Passport/Arm.png',
  '/Visa/bg.webp',
  '/Visa/layer-1.webp',
  '/Logs/bg.webp',
  '/Logs/entry.webp',
  '/Logs/exit.webp',
];

export const ASSET_PAGE_IMAGES = [
  '/Asset/bg.webp',
  '/Asset/score.webp',
  '/Asset/supply.webp',
  '/Asset/character.webp',
  '/Asset/story.webp',
];

export const SCORE_PAGE_IMAGES = [
  '/Score/bg.webp',
];

export const NIGHT_PAGE_IMAGES = [
  '/Home/night.png',
];

export const REGISTER_IMAGES = [
  '/bg.webp',
  '/logo.webp',
];

export const ROUTE_IMAGE_MAP = {
  '/': [...HOME_MENU_ICONS, ...HOME_QUICK_ACTIONS, ...CHARACTER_CAROUSEL_IMAGES],
  '/passport': PASSPORT_IMAGES,
  '/assets': ASSET_PAGE_IMAGES,
  '/scores': SCORE_PAGE_IMAGES,
  '/night': NIGHT_PAGE_IMAGES,
  '/register': REGISTER_IMAGES,
};

export const CRITICAL_IMAGES = [
  '/logo.webp',
  '/bg.webp',
  ...CHARACTER_CAROUSEL_IMAGES.slice(0, 2),
  ...HOME_MENU_ICONS.slice(0, 3),
];

export const BACKGROUND_IMAGES = [
  ...new Set([
    '/bg.webp',
    '/Passport/bg.webp',
    '/Visa/bg.webp',
    '/Visa/layer-1.webp',
    '/Logs/bg.webp',
    '/Asset/bg.webp',
    '/Score/bg.webp',
  ]),
];
